import { render, staticRenderFns } from "./Dewormings.vue?vue&type=template&id=a2c79e54&"
import script from "./Dewormings.vue?vue&type=script&lang=js&"
export * from "./Dewormings.vue?vue&type=script&lang=js&"
import style0 from "./Dewormings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports